import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { AttachFile } from '@material-ui/icons';
import { PrimaryButton, SecondaryButton } from '../../../shared/ui';
import {
  CardTitle,
  SectionCard,
  StepHint,
  WarningBox,
} from '../styles';

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return '-';
  return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
};

const NotaRemessaSection = ({ notaRemessaFile, onNotaRemessaFileChange, currentLanguage }) => {
  const clientLang = currentLanguage?.bepiService?.client || {};
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFile = event?.target?.files?.[0] || null;
    onNotaRemessaFileChange(selectedFile);
  };

  const handleRemoveFile = () => {
    onNotaRemessaFileChange(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <SectionCard>
      <CardTitle>
        {clientLang.client_quote_details_step_invoices || 'Anexar Nota de Remessa'}
      </CardTitle>
      <StepHint>
        Selecione a nota de remessa para concluir o aceite da estimativa.
      </StepHint>

      <WarningBox>
        Formatos permitidos: PDF, JPG, JPEG, PNG. Tamanho maximo: 10MB.
      </WarningBox>

      <input
        ref={fileInputRef}
        type='file'
        accept='.pdf,.jpg,.jpeg,.png'
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
        <PrimaryButton type='button' onClick={() => fileInputRef.current?.click()}>
          <AttachFile style={{ marginRight: 8 }} />
          Selecionar arquivo
        </PrimaryButton>

        {notaRemessaFile ? (
          <SecondaryButton type='button' onClick={handleRemoveFile}>
            Remover arquivo
          </SecondaryButton>
        ) : null}
      </div>

      {notaRemessaFile ? (
        <div style={{ fontSize: 14, color: '#334155' }}>
          <strong>Arquivo:</strong> {notaRemessaFile.name} ({formatFileSize(notaRemessaFile.size)})
        </div>
      ) : (
        <div style={{ fontSize: 14, color: '#64748B' }}>
          Nenhum arquivo selecionado.
        </div>
      )}
    </SectionCard>
  );
};

NotaRemessaSection.propTypes = {
  notaRemessaFile: PropTypes.object,
  onNotaRemessaFileChange: PropTypes.func.isRequired,
  currentLanguage: PropTypes.object,
};

NotaRemessaSection.defaultProps = {
  notaRemessaFile: null,
  currentLanguage: {},
};

export default NotaRemessaSection;
